module.exports = __webpack_public_path__ + "static/AngelaHe0-2b8fc8e794aae627048b2f3e99e5059d.png";